import { BaseModel, Default } from "@red/data-access";
import { Expose, Transform, Type } from "class-transformer";

export class EnhancedLeadershipDesignationCreateDto extends BaseModel {
  @Expose()
  @Transform(({ value }) => value.trim())
  code!: string;

  @Expose()
  @Transform(({ value }) => value.trim())
  name!: string;

  @Expose()
  @Type(() => Number)
  sequence!: number | null;

}

export class EnhancedLeadershipDesignationUpdateDto extends EnhancedLeadershipDesignationCreateDto {
}

